import {
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { handleToast, isValuePresent } from "../../utils";
import { handle_Active_recording } from "../../services/api/recording";
import ZoomOUT from "../Bank Account/Zoom";
import { getBankApprove } from "../../services/api/bank";
import { postApicredentials } from "../../services/api/application";
import { postConsultantUserRecharge } from "../../services/api/consultant";
import { toast } from "react-toastify";

function Pop(props) {
  const {
    openPopup,
    setOpenPopup,
    showdata,
    id,
    setReload,
    credentials,
    balance_data,
    Consultant_name,
    PK_bank,
    SK_bank,
    credentialsData = [],
    data_id,
  } = props;
  const [loader, setLoader] = useState(false);
  // eslint-disable-next-line
  const [Credentials_Data, setCredentials_Data] = useState("");
  const [amount, setAmount] = useState(null);
  const balance_amount = Math.round(Number(balance_data));
  const [activeZoom, setActiveZoom] = useState(null);
  const [recharge, setRecharge] = useState("");
  const [description, setDescription] = useState("");
  const isMobile = window.innerWidth <= 600;

  const handleState = (voiceid) => {
    setLoader(true);
    const data = {
      consultant_id: id,
      voice_id: voiceid,
    };
    try {
      handle_Active_recording(data)
        .then((response) => {
          setOpenPopup(false);
          setReload((prev) => !prev);
          setLoader(false);
          toast.success(response?.data?.message, {
            position: isMobile ? "top-left" : "top-center",
            style: {
              width: isMobile ? "300px" : "400px",
              textWrap: isMobile && "wrap",
            },
          });
        })
        .catch((error) => {
          handleToast(error?.response?.data);
          setLoader(false);
          return;
        });
    } catch (error) {
      handleToast(error?.response?.data);
      console.log(error);
      setLoader(false);
      return;
    }
  };

  const handleAmount = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    // If empty or zero or more than balance, block further action
    if (value === 0 || Number(value) > balance_amount) {
      return;
    } else if (0 <= balance_amount) {
      setAmount(value);
    }
  };

  const handleState2 = (bankid) => {
    setLoader(true);
    const data = {
      PK: PK_bank,
      SK: SK_bank,
      bank_details_id: bankid,
    };
    try {
      getBankApprove(data)
        .then((response) => {
          setOpenPopup(false);
          setReload((prev) => !prev);
          setLoader(false);
          toast.success(response?.data?.message, {
            position: isMobile ? "top-left" : "top-center",
            style: {
              width: isMobile ? "300px" : "400px",
              textWrap: isMobile && "wrap",
            },
          });
        })
        .catch((error) => {
          handleToast(error?.response?.data);
          setLoader(false);
          return;
        });
    } catch (error) {
      handleToast(error?.response?.data);
      console.log(error);
      setLoader(false);
      return;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    const data = {
      credential_id: Credentials_Data,
      settled_amount: amount,
      consultant_id: data_id,
    };
    try {
      postApicredentials(data)
        .then((response) => {
          if (response.data.status === "success") {
            toast.success(response?.data?.message, {
              position: isMobile ? "top-left" : "top-center",
              style: {
                width: isMobile ? "300px" : "400px",
                textWrap: isMobile && "wrap",
              },
            });
            setLoader(false);
            setAmount("");
            setCredentials_Data("");
          }
        })
        .catch((error) => {
          handleToast(error?.response?.data || "Failed");
          setLoader(false);
          return;
        });
    } catch (error) {
      handleToast(error?.response?.data);
      console.log(error);
      return;
    }
  };

  const handleRechargeValue = (e) => {
    const inputValue = e.target.value;
    // Allow only numbers (including empty value to allow backspacing)
    if (/^\d*$/.test(inputValue)) {
      if (inputValue > 0 || inputValue === "") {
        setRecharge(inputValue);
      }
    }
  };

  const handleUserRecharge = (e) => {
    e.preventDefault();
    setLoader(true);
    const data = {
      id: showdata.id,
      role: showdata.role,
      amount: recharge,
      description: description,
    };
    try {
      postConsultantUserRecharge(data)
        .then(() => {
          setOpenPopup(false);
          setReload((prev) => !prev);
          setLoader(false);
          setRecharge("");
          setDescription("");
          toast.success("Recharge amount added successfully", {
            position: isMobile ? "top-left" : "top-center",
            style: {
              width: isMobile ? "300px" : "400px",
              textWrap: isMobile && "wrap",
            },
          });
        })
        .catch((error) => {
          handleToast(error?.response?.data);
          setLoader(false);
          return;
        });
    } catch (error) {
      handleToast(error?.response?.data);
      console.log(error);
      setLoader(false);
      return;
    }
  };

  return (
    <>
      {
        !credentials ? (
          // FOR RECORDING
          // >>>>>START
          <Dialog open={openPopup} fullWidth>
            <DialogTitle
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "30px",
              }}
            >
              <div>
                <h2>Pending Intro Recordings</h2>
              </div>
              <button
                onClick={() => setOpenPopup(false)}
                style={{
                  border: "none",
                  background: "none",
                }}
              >
                <ClearIcon />
              </button>
            </DialogTitle>
            {""}
            <DialogContent>
              {!loader ? (
                <div
                  style={{
                    maxHeight: "500px",
                    // background:'red',
                    marginTop: "30px",
                  }}
                >
                  {showdata.map((items) => {
                    return (
                      <div
                        style={{
                          height: "60px",
                          borderBottom: "2px solid #1c1c1c1c",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginBottom: "3px",
                        }}
                      >
                        <div
                          style={{
                            padding: "10px",
                          }}
                        >
                          <audio controls className="recording">
                            {" "}
                            <source src={items.url} />
                          </audio>
                        </div>
                        <div
                          style={{
                            width: "50%",
                            padding: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Chip
                            onClick={() => {
                              handleState(items.id);
                            }}
                            label="Approve"
                            //    color="warning"
                            style={{ background: "var(--admin-page-color)", color: "#FFFF" }}
                            //    variant="outlined"
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div
                  style={{
                    height: "400px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress
                    style={{
                      color: "var(--admin-page-color)",
                    }}
                  />
                </div>
              )}
            </DialogContent>
          </Dialog>
        ) : // >>>>>END
        credentials === "bank" || credentials === "approve_bank" ? (
          // FOR BANK LIST
          // >>>>>>>>
          <Dialog
            open={openPopup}
            maxWidth={credentials === "approve_bank" ? "lg" : "xl"}
            fullWidth
          >
            <DialogTitle
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "30px",
              }}
            >
              <div>
                <h2>Bank Account List</h2>
              </div>
              <button
                onClick={() => setOpenPopup(false)}
                style={{
                  border: "none",
                  background: "none",
                }}
              >
                <ClearIcon />
              </button>
            </DialogTitle>
            {""}
            <DialogContent>
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                }}
              >
                <h5
                  style={{
                    width: "120px",
                  }}
                >
                  Bank
                </h5>
                <h5
                  style={{
                    width: "200px",
                  }}
                >
                  Account Number
                </h5>
                <h5
                  style={{
                    width: "250px",
                    textAlign: "center",
                  }}
                >
                  Id
                </h5>
                <h5
                  style={{
                    width: "150px",
                    textAlign: "center",
                  }}
                >
                  Account Type
                </h5>
                <h5
                  style={{
                    width: "180px",
                    textAlign: "center",
                  }}
                >
                  IFSC
                </h5>
                <h5
                  style={{
                    width: "200px",
                    textAlign: "center",
                  }}
                >
                  Passbook Image
                </h5>
                <h5
                  style={{
                    width: "180px",
                    textAlign: "center",
                    display: credentials === "approve_bank" && "none",
                  }}
                >
                  Approve
                </h5>
              </div>
              {!loader ? (
                <div
                  style={{
                    maxHeight: "500px",
                    marginTop: "30px",
                  }}
                >
                  {isValuePresent(showdata) &&
                    (credentials === "bank" ? showdata : [showdata]).map(
                      (items) => {
                        return (
                          <div
                            style={{
                              height: "60px",
                              borderBottom: "2px solid #1c1c1c1c",
                              display: "flex",
                              gap: "15px",
                              alignItems: "center",
                              marginBottom: "3px",
                            }}
                          >
                            <h6
                              style={{
                                width: "120px",
                              }}
                            >
                              {items?.bank_name || ""}
                            </h6>
                            <h6
                              style={{
                                width: "200px",
                                textAlign: "center",
                              }}
                            >
                              {items?.account_number || ""}
                            </h6>
                            <h6
                              style={{
                                width: "250px",
                                textAlign: "center",
                              }}
                            >
                              {items?.bank_details_id || ""}
                            </h6>
                            <h6
                              style={{
                                width: "150px",
                                textAlign: "center",
                              }}
                            >
                              {items?.account_type || ""}
                            </h6>
                            <h6
                              style={{
                                width: "180px",
                                textAlign: "center",
                              }}
                            >
                              {items?.ifsc || ""}
                            </h6>
                            <span
                              style={{
                                width: "200px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <ZoomOUT
                                imageUrl={items?.passbook_image || ""}
                                key={items?.bank_details_id || ""}
                                zoomKey={items?.bank_details_id || ""}
                                activeZoom={activeZoom}
                                setActiveZoom={setActiveZoom}
                              />
                            </span>
                            <span
                              style={{
                                width: "180px",
                                textAlign: "center",
                                display:
                                  credentials === "approve_bank" && "none",
                              }}
                            >
                              <Chip
                                onClick={() => {
                                  handleState2(items?.bank_details_id || "");
                                }}
                                label="Approve"
                                style={{
                                  background: "var(--admin-page-color)",
                                  color: "#FFFF",
                                }}
                              />
                            </span>
                          </div>
                        );
                      },
                    )}
                  {!isValuePresent(showdata) && (
                    <div
                      style={{
                        width: "100%",
                        height: "200px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <h2>Data Not Found</h2>
                    </div>
                  )}
                </div>
              ) : (
                <div
                  style={{
                    height: "400px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress
                    style={{
                      color: "var(--admin-page-color)",
                    }}
                  />
                </div>
              )}
            </DialogContent>
          </Dialog>
        ) : // >>>>>>>>END
        credentials === "recharge_open" ? (
          // FOR RECHARGE
          // >>>>>START
          <Dialog open={openPopup} fullWidth>
            <DialogTitle
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "30px",
              }}
            >
              <div>
                <h3>Recharge Amount </h3>
                <h5>Balance : ₹{Math.round(Number(showdata?.balance)) || 0}</h5>
              </div>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <img
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                  src={showdata?.photo || ""}
                  alt=""
                />
                <div
                  style={{
                    textAlign: "center",
                    marginTop: "20px",
                  }}
                >
                  <h5>{showdata?.name || ""}</h5>
                </div>
              </span>
            </DialogTitle>
            {""}
            {!loader ? (
              <DialogContent>
                <form onSubmit={handleSubmit}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "20px",
                    }}
                  >
                    <span>
                      <label htmlFor="">
                        Add Balance <sup style={{ color: "red" }}>*</sup>
                      </label>
                      <input
                        type="tel"
                        value={recharge}
                        onChange={handleRechargeValue}
                        placeholder="Enter Amount"
                        style={{
                          background: "white",
                          boxShadow: "none",
                          border: "2px solid rgba(28, 28, 28, 0.26)",
                          borderRadius: "5px",
                          color: "#1c1c1cc8",
                          width: "100%",
                          height: "40px",
                          padding: "10px",
                        }}
                        required
                      />
                    </span>
                    <span>
                      <label htmlFor="">
                        Description <sup style={{ color: "red" }}>*</sup>
                      </label>
                      <input
                        type="text"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Enter Description"
                        style={{
                          background: "white",
                          boxShadow: "none",
                          border: "2px solid rgba(28, 28, 28, 0.26)",
                          borderRadius: "5px",
                          color: "#1c1c1cc8",
                          width: "100%",
                          height: "40px",
                          padding: "10px",
                        }}
                        required
                      />
                    </span>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        gap: "20px",
                      }}
                    >
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenPopup(false);
                          setRecharge("");
                          setDescription("");
                        }}
                        style={{
                          border: "none",
                          padding: "10px",
                          color: "black",
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        style={{
                          border: "none",
                          padding: "10px",
                          background: "var(--admin-page-color)",
                          color: "#FFFF",
                          borderRadius: "5px",
                        }}
                        onClick={(e) => {
                          handleUserRecharge(e);
                        }}
                      >
                        Recharge
                      </button>
                    </span>
                  </div>
                </form>
              </DialogContent>
            ) : (
              <div
                style={{
                  height: "400px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress
                  style={{
                    color: "var(--admin-page-color)",
                  }}
                />
              </div>
            )}
          </Dialog>
        ) : (
          // >>>>>END
          // FOR TRANSFER_FUNDS
          // >>>>>START
          <Dialog open={openPopup} fullWidth>
            <DialogTitle
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "30px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <h4>{Consultant_name}</h4>
                <h4>₹{balance_amount}</h4>
              </div>
              <button
                onClick={() => setOpenPopup(false)}
                style={{
                  border: "none",
                  background: "none",
                  paddingBottom: "30px",
                }}
              >
                <ClearIcon />
              </button>
            </DialogTitle>

            {!loader ? (
              <DialogContent>
                <form onSubmit={handleSubmit}>
                  <div
                    style={{
                      // height:'400px',
                      display: "flex",
                      flexDirection: "column",
                      gap: "20px",
                    }}
                  >
                    <span>
                      <label htmlFor="">
                        Credentials <sup style={{ color: "red" }}>*</sup>
                      </label>
                      <Select
                        value={Credentials_Data}
                        onChange={(e) => setCredentials_Data(e.target.value)}
                        id="app-language"
                        autoComplete="AppLanguage"
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        style={{
                          background: "white",
                          boxShadow: "none",
                          border: "0.9px solid #1c1c1c1f",
                          borderRadius: "5px",
                          color: "#1c1c1cc8",
                          width: "100%",
                          height: "40px",
                          marginTop: "8px",
                        }}
                        required
                      >
                        <MenuItem value="" disabled>
                          Enter Your Credential
                        </MenuItem>
                        {credentialsData.map((data, x) => {
                          return (
                            <MenuItem value={data.key_id} key={x}>
                              {data.name}---{data.key_id}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </span>
                    {""}
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="">
                        {" "}
                        Transfer fund <sup style={{ color: "red" }}>*</sup>
                      </label>
                      <input
                        type="tel"
                        value={amount}
                        onChange={handleAmount}
                        placeholder="Enter Your Transfer Fund"
                        style={{
                          background: "white",
                          boxShadow: "none",
                          border: "2px solid rgba(28, 28, 28, 0.26)",
                          borderRadius: "5px",
                          color: "#1c1c1cc8",
                          width: "100%",
                          height: "40px",
                          padding: "10px",
                        }}
                        required
                      />
                    </span>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        gap: "20px",
                      }}
                    >
                      <button
                        style={{
                          border: "none",
                          padding: "10px",
                          background: "var(--admin-page-color)",
                          color: "#FFFF",
                          borderRadius: "5px",
                        }}
                      >
                        Transfer Fund
                      </button>
                      <button
                        style={{
                          border: "none",
                          padding: "10px",
                          borderRadius: "5px",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenPopup(false);
                        }}
                      >
                        Cancel
                      </button>
                    </span>
                  </div>
                </form>
              </DialogContent>
            ) : (
              <div
                style={{
                  height: "400px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress
                  style={{
                    color: "var(--admin-page-color)",
                  }}
                />
              </div>
            )}
          </Dialog>
        )
        // >>>>END
      }
    </>
  );
}

export default Pop;
